import { isOutboundCompanyValid } from '../IdwellToIdwell.utils'
import { IdwellToIdwellSubMenuCompanyListItem } from '../IdwellToIdwellSubMenuCompanyListItem'

import * as styles from './IdwellToIdwellSubMenuCompanyList.module.css'

function IdwellToIdwellSubMenuCompanyList({
  activeKey,
  className = styles.IdwellToIdwellSubMenuCompanyList,
  items,
  selected,
  selectedKey,
  titleKey,
  onClick,
}) {
  return (
    <div className={className}>
      {items?.map(item => (
        <IdwellToIdwellSubMenuCompanyListItem
          isActive={isOutboundCompanyValid({ activeKey, company: item })}
          item={item}
          key={item[selectedKey]}
          selected={selected?.[selectedKey] === item[selectedKey]}
          onClick={onClick}
        >
          {item[titleKey]}
        </IdwellToIdwellSubMenuCompanyListItem>
      ))}
    </div>
  )
}

export default IdwellToIdwellSubMenuCompanyList
